var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoReservation = function SvgNoReservation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 194 194",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 42.134H70.929c-2.471.003-4.473 2.013-4.476 4.493v116.159l-.597.183-12.774 3.926a2.388 2.388 0 0 1-2.98-1.59L12.104 40.73a2.398 2.398 0 0 1 1.584-2.992l19.685-6.05L90.44 14.156l19.685-6.05a2.376 2.376 0 0 1 1.818.173c.56.298.978.807 1.163 1.414l9.712 31.842.182.6z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.818 42.006 122.132 3.604a5.086 5.086 0 0 0-2.466-3.009 5.035 5.035 0 0 0-3.858-.372l-27.63 8.509-56.967 17.546L3.582 34.79c-2.672.825-4.176 3.672-3.36 6.362l39.94 131.243A5.076 5.076 0 0 0 45.007 176c.502 0 1.001-.076 1.48-.225l18.94-5.832.596-.186v-.626l-.596.183-19.115 5.889c-2.359.723-4.855-.61-5.58-2.982L.795 40.975a4.514 4.514 0 0 1 .324-3.425 4.468 4.468 0 0 1 2.64-2.188l27.629-8.511L88.355 9.307 115.984.796a4.49 4.49 0 0 1 1.313-.198 4.476 4.476 0 0 1 4.266 3.18l11.633 38.228.184.6h.62l-.182-.6z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.561 38a2.701 2.701 0 0 1-2.581-1.9l-3.862-12.555a2.674 2.674 0 0 1 .197-2.046c.336-.629.909-1.1 1.593-1.308L84.651 4.118a2.703 2.703 0 0 1 3.37 1.781l3.86 12.555a2.687 2.687 0 0 1-1.79 3.355L37.35 37.882a2.698 2.698 0 0 1-.788.118z",
    fill: "var(--colors-brand)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "var(--colors-brand)",
    cx: 57,
    cy: 7,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 57,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.462 174H78.538A2.54 2.54 0 0 1 76 171.462V50.538A2.54 2.54 0 0 1 78.538 48h100.924A2.54 2.54 0 0 1 182 50.538v120.924a2.541 2.541 0 0 1-2.538 2.538z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.037 42H71.084A5.089 5.089 0 0 0 66 47.08v121.842l.598-.182V47.08a4.49 4.49 0 0 1 4.486-4.482h63.139l-.186-.598zm54.879 0H71.084A5.089 5.089 0 0 0 66 47.08v136.84a5.089 5.089 0 0 0 5.084 5.08h117.832a5.089 5.089 0 0 0 5.084-5.08V47.08a5.089 5.089 0 0 0-5.084-5.08zm4.486 141.92a4.49 4.49 0 0 1-4.486 4.482H71.084a4.49 4.49 0 0 1-4.486-4.481V47.079a4.49 4.49 0 0 1 4.486-4.481h117.832a4.49 4.49 0 0 1 4.486 4.481v136.842z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.327 55h-54.654c-1.475-.002-2.671-1.236-2.673-2.758V38.758c.002-1.522 1.198-2.756 2.673-2.758h54.654c1.475.002 2.671 1.236 2.673 2.758v13.484c-.002 1.522-1.198 2.756-2.673 2.758z",
    fill: "var(--colors-brand)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "var(--colors-brand)",
    cx: 129,
    cy: 32,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 129,
    cy: 32,
    r: 4
  }))));
};

export default SvgNoReservation;